import React, { useState } from 'react';
import './App.css';
import { FaLinkedin, FaGithub, FaEnvelope, FaChevronDown, FaChevronLeft, FaChevronRight, FaTimes, FaArrowUp, FaChevronUp, FaSearchPlus } from 'react-icons/fa';

const projects = [
  {
    id: 1,
    title: "Projeto CAPE",
    description: "Plataforma de gestão para educação inclusiva. Utiliza IA (OpenAI) para transformar anotações simples em relatórios técnicos padronizados. Desenvolvido com Django, Python e AWS.",
    images: [ "/img/cape1.jpg", "/img/cape2.jpg", "/img/cape3.jpg" ]
  },
  {
    id: 2,
    title: "Sistema Rota (Residência CEPEDI)",
    description: "Módulo financeiro para cálculo de comissões logísticas. Arquitetura em .NET 8 (Clean Architecture) e Front-end em Angular 19. Conta com simulação de cenários e relatórios dinâmicos.",
    images: [ "/img/rota1.jpg", "/img/rota2.jpg", "/img/rota3.jpg" ]
  }
];

const personalProjects = [
  {
    id: "p1",
    title: "Slime Combat II - Pygame RPG",
    description: "RPG por turnos feito em Python para estudo de Estruturas de Dados. Implementa Min-Heap para balanceamento de dificuldade e Fila (Queue) para sistema de turnos.",
    image: "/img/slime-combat.jpg", 
    tech: "Python | Pygame | Heap & Queue",
    codeSnippet: `class MinHeap:
    def upHeap(self, index):
        # Balanceamento de Dificuldade
        # Se o pai for 'mais forte' (level maior), troca.
        while(self.hasFather(index) and 
              self.father(index).level > self.storage[index].level):
            self.swap(self.fatherIndex(index),index)
            index = self.fatherIndex(index)`
  },
  {
    id: "p2",
    title: "Blackjack Multiplayer (Sockets)",
    description: "Jogo de cartas em tempo real com arquitetura Cliente-Servidor. Usa Sockets TCP/IP puros e Threading para gerenciar conexões simultâneas e estado do jogo.",
    image: "/img/blackjack-net.jpg", 
    tech: "Python | Sockets TCP | Threading",
    codeSnippet: `class ServidorBlackjack:
    def start(self):
        self.socket.bind((self.ip, self.porta))
        self.socket.listen(2)
        
        # Threads para conexões simultâneas
        for id in range(2):
            conn, addr = self.socket.accept()
            t = threading.Thread(target=self.processar, 
                               args=(id,))
            t.start()`
  }
];

const ImageGallery = ({ images, onZoom }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const total = images.length;
  
  const getPrev = (idx) => (idx === 0 ? total - 1 : idx - 1);
  const getNext = (idx) => (idx === total - 1 ? 0 : idx + 1);

  const handlePrev = (e) => { e.stopPropagation(); setCurrentIndex(getPrev(currentIndex)); };
  const handleNext = (e) => { e.stopPropagation(); setCurrentIndex(getNext(currentIndex)); };

  const handleZoom = (e) => {
    e.stopPropagation();
    onZoom(images, currentIndex);
  };

  if (total < 3) return null;

  return (
    <div className="carousel-3d-container">
      <button className="carousel-nav left" onClick={handlePrev}><FaChevronLeft /></button>
      <div className="carousel-track">
        <div className="carousel-card left" onClick={handlePrev}>
          <img src={images[getPrev(currentIndex)]} alt="prev" />
          <div className="blur-overlay"></div>
        </div>
        <div className="carousel-card center" onClick={handleZoom}>
          <img src={images[currentIndex]} alt="curr" />
          <div className="zoom-indicator">
            <FaSearchPlus />
          </div>
        </div>
        <div className="carousel-card right" onClick={handleNext}>
          <img src={images[getNext(currentIndex)]} alt="next" />
          <div className="blur-overlay"></div>
        </div>
      </div>
      <button className="carousel-nav right" onClick={handleNext}><FaChevronRight /></button>
    </div>
  );
};

function App() {
  const [activeTab, setActiveTab] = useState(personalProjects[0].id);
  const [currentSection, setCurrentSection] = useState(0); 

  const [lightbox, setLightbox] = useState({ 
    isOpen: false, 
    images: [], 
    index: 0 
  });

  const activeProject = personalProjects.find(p => p.id === activeTab);

  const goToSection = (index) => setCurrentSection(index);

  const openLightbox = (images, index) => {
    setLightbox({ isOpen: true, images, index });
  };
  
  const closeLightbox = () => {
    setLightbox({ ...lightbox, isOpen: false });
  };

  const nextLightboxImage = (e) => {
    e.stopPropagation();
    setLightbox((prev) => ({
      ...prev,
      index: (prev.index + 1) % prev.images.length
    }));
  };

  const prevLightboxImage = (e) => {
    e.stopPropagation();
    setLightbox((prev) => ({
      ...prev,
      index: (prev.index - 1 + prev.images.length) % prev.images.length
    }));
  };

  return (
    <div className="app">
      
      <div className="main-slider" style={{ transform: `translateY(-${currentSection * 100}vh)` }}>
        
        <section className="hero">
          <div className="content-scroll">
            <div className="profile-container">
              <img src="/img/minha-foto.jpg" alt="Pablo Cezar" className="profile-pic" />
            </div>
            <h1>Pablo Cezar</h1>
            <p className="bio">Bacharel em Ciência da Computação (UESC) <br /> Dev Full Stack | Python, .NET, React, TypeScript e IA</p>
            <div className="social-links">
              <a href="mailto:pablocezar09@gmail.com"><FaEnvelope /></a>
              <a href="https://linkedin.com/in/pablo-cezar0" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
              <a href="https://github.com/PabloCezar0" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
            </div>
          </div>
          <button className="scroll-down" onClick={() => goToSection(1)}>
            <span className="scroll-text">Projetos</span>
            <FaChevronDown className="bounce" />
          </button>
        </section>

        <section className="projects-section fullscreen-section">
          <button className="scroll-up" onClick={() => goToSection(0)}>
            <FaChevronUp />
            <span className="scroll-text">Início</span>
          </button>
          
          <div className="content-scroll">
            <h2>Principais Projetos</h2>
            <div className="projects-list">
              {projects.map((proj) => (
                <div key={proj.id} className="project-card">
                  <h3>{proj.title}</h3>
                  <p>{proj.description}</p>
                  <ImageGallery images={proj.images} onZoom={openLightbox} />
                </div>
              ))}
            </div>
          </div>

          <button className="scroll-down" onClick={() => goToSection(2)}>
            <span className="scroll-text">Pessoais</span>
            <FaChevronDown className="bounce" />
          </button>
        </section>

        <section className="personal-section fullscreen-section">
          <button className="scroll-up" onClick={() => goToSection(1)}>
            <FaChevronUp />
            <span className="scroll-text">Principais</span>
          </button>

          <div className="content-scroll">
            <h2>Projetos Para Estudos</h2>
            <div className="tabs-container">
              {personalProjects.map((proj) => (
                <button 
                  key={proj.id} 
                  className={`tab-btn ${activeTab === proj.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(proj.id)}
                >
                  {proj.title.split(" - ")[0]}
                </button>
              ))}
            </div>

            <div className="centered-wrapper">
              <div className="project-card personal-card-layout fade-in">
                <div className="personal-info">
                  <h3>{activeProject.title}</h3>
                  <p className="tech-badge">{activeProject.tech}</p>
                  <p>{activeProject.description}</p>
                  <img src={activeProject.image} alt={activeProject.title} className="single-project-img"/>
                </div>
                <div className="code-block-container">
                  <span className="code-label">Snippet de Código</span>
                  <pre>
                    <code>{activeProject.codeSnippet}</code>
                  </pre>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div> 

      {lightbox.isOpen && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="close-btn"><FaTimes /></button>
          <button className="nav-btn left" onClick={prevLightboxImage}>
            <FaChevronLeft />
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={lightbox.images[lightbox.index]} 
              className="lightbox-img" 
              alt="Zoom" 
            />
          </div>
          <button className="nav-btn right" onClick={nextLightboxImage}>
            <FaChevronRight />
          </button>
        </div>
      )}

      {currentSection > 0 && !lightbox.isOpen && (
        <button className="back-to-top" onClick={() => goToSection(0)}>
          <FaArrowUp />
        </button>
      )}

    </div>
  );
}

export default App;